import moment from 'moment';
import { ODataObject } from '../../interfaces/odata-model.interface';
import { DateModel } from '../primitive/date.model';
import { TextModel } from '../primitive/text.model';
import { TimeModel } from '../primitive/time.model';
import { CodeModel } from './code.model';
import { CompositeModel } from './composite.model';

export class CrmCodeModel extends CompositeModel {
    public codeType: TextModel;
    public qKatArt: TextModel;
    public codeGroup: TextModel;
    public code: TextModel;
    public codeText: TextModel;
    public startDate: DateModel;
    public startTime: TimeModel;
    public endDate: DateModel;
    public endTime: TimeModel;
    public constructor({
        codeType = '',
        qKatArt = '',
        codeGroup,
        code,
        codeText = '',
        startDateTime,
        endDateTime,
    }: {
        codeType?: string;
        qKatArt?: string;
        codeGroup: string;
        code: string;
        codeText?: string;
        startDateTime?: moment.Moment | undefined;
        endDateTime?: moment.Moment | undefined;
    }) {
        super('CrmCodeModel');

        this.codeType = <TextModel>this.set(new TextModel('Codetype', codeType));
        this.qKatArt = <TextModel>this.set(new TextModel('Qkatart', qKatArt));
        this.codeGroup = <TextModel>this.set(new TextModel('Codegroup', codeGroup));
        this.code = <TextModel>this.set(new TextModel('Code', code));
        this.codeText = <TextModel>this.set(new TextModel('Codlt', codeText));
        this.startDate = <DateModel>this.set(new DateModel('StartDate', startDateTime));
        this.startTime = <TimeModel>this.set(new TimeModel('StartTime', startDateTime));
        this.endDate = <DateModel>this.set(new DateModel('EndDate', endDateTime));
        this.endTime = <TimeModel>this.set(new TimeModel('EndTime', endDateTime));
    }

    public toJSON(): unknown {
        return {
            codeType: this.codeType.value,
            qKatArt: this.qKatArt.value,
            codeGroup: this.codeGroup.value,
            code: this.code.value,
            codeText: this.codeText.value,
            startDateTime: this.startDate.value, // star tDate and startTime share the same moment object
            endDateTime: this.endDate.value, // endD ate and endTime share the same moment object
        };
    }

    public static fromCodeModel(codeModel: CodeModel): CrmCodeModel {
        return new CrmCodeModel({
            codeType: codeModel.codeType.value,
            qKatArt: codeModel.qkatart.value,
            codeGroup: codeModel.codeGroup.value,
            code: codeModel.codeName.value,
            codeText: codeModel.codeDesc.value,
        });
    }

    public getOutModel(): ODataCrmCodeOutModel {
        return <ODataCrmCodeOutModel>super.getOutModel();
    }
}

export class CrmCodeModelFromJson extends CrmCodeModel {
    public constructor(data: JsonCrmCodeModel) {
        const startDateTime = data.startDateTime ? moment(data.startDateTime) : undefined;
        const endDateTime = data.endDateTime ? moment(data.endDateTime) : undefined;

        super({
            codeType: data.codeType,
            qKatArt: data.qKatArt,
            codeGroup: data.codeGroup,
            code: data.code,
            codeText: data.codeText,
            startDateTime,
            endDateTime,
        });
    }
}

export interface JsonCrmCodeModel {
    codeType: string;
    qKatArt: string;
    codeGroup: string;
    code: string;
    codeText: string;
    startDateTime: string;
    endDateTime: string;
}

export interface ODataCrmCodeOutModel extends ODataObject {
    Codetype: string;
    Qkatart: string;
    Codegroup: string;
    Code: string;
    Codlt: string;
    StartDate: string;
    StartTime: string;
    EndDate: string;
    EndTime: string;
}
